import { render, staticRenderFns } from "./mobileGames.vue?vue&type=template&id=b0b03c4c&scoped=true"
import script from "./mobileGames.vue?vue&type=script&lang=ts"
export * from "./mobileGames.vue?vue&type=script&lang=ts"
import style0 from "./mobileGames.vue?vue&type=style&index=0&id=b0b03c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b03c4c",
  null
  
)

export default component.exports